export default {
  getDashboard: state => state.dashboard,
}
